<template>
  <div>
    <el-form :model="row" ref="formRef" :rules="formRules" label-suffix=':' label-width="100px">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="项目名称" prop="projectId">
            <el-select
              v-model="row.projectId"
              style="width:100%"
              placeholder="请选择"
              @change="projectIdChange"
              :disabled="model=='update'"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="权限成员" prop="userIdList">
               <choicePeople ref="transformPeopleRef"  :option="choicePeopleOption" @getPeople="transformGetPeople" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="合同类型" prop="type">
               <el-radio-group v-model="row.type">
                    <el-radio v-for='(item ,index) in contractTypeList' :label="item.dictKey" :key="index">{{item.dictValue}}</el-radio>

                </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div style="float:right">
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
                保存
            </el-button>
            <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getBisDictData, save,  update  } from '@/api/crmedical/contract/contractSetting/contractSetting';
import choicePeople from '@/components/choicePeopleOrDept/choicePeopleInput.vue';

export default {
    props:['row',],
    components:{choicePeople},
  data() {
    var checkUser = (rule, value, callback) => {
        console.log('加偶按',value)
        if (value.length==0) {
          return callback(new Error('权限成员不能为空'));
        }else{
          callback();
        }
      
      };
    return {
        projectList:[],
        form:{
            projectId:'',
            code:'',
            name:'',
            description:''
        },
        contractTypeList:[],
        model:'',
      formRules: {
        projectId: [{ required: true, message: '项目名称不能为空', trigger: 'blur' }],
        userIdList:[{ required: true, trigger: 'change',message: '权限成员不能为空'},{ validator: checkUser,trigger: 'blur'}],
        type: [{ required: true, message: '请选择合同类型', trigger: 'change' }],
        // name: [{ required: true, message: '设备名称不能为空', trigger: 'blur' }],

      },
       choicePeopleOption: {
        projectId: '',
        variable: '',
        searchType: '',
        deptId: '',
        model: 'unlimitPeople', //singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
        selectList: [], //已选的集合
        prohibitList: [], //禁止选的集合
        limit: 20,
      },
    };
  },
  created(){
      console.log('656',this.row)
      this.initData()
      this.getContractTypeList()
      if(!this.row.id){
          this.model = 'add'
      }else{
          this.model = 'update'
          this.handlePeople()
          this.row.type = this.row.type+''
          if( this.row.userIdList.length ==0){
            this.row.userIdList = this.row.userIds.split(',')
          }
      }
      this.choicePeopleOption .projectId = this.row.projectId
  },
  methods:{
      handlePeople(){
          let idArry = this.row.userIds.split(',')
          let nameArry = this.row.userNames.split('、')
          let length = idArry.length
          for(let i =0;i<length;i++){
              let obj ={
                   id:idArry[i],
                    realName:nameArry[i],
              }
              this.choicePeopleOption.selectList.push(obj)
          }
      },
       async initData() {
      await getProjectList().then((res) => {
        this.projectList = res.data;

      });

    },
    saveRecord(){
         this.$refs['formRef'].validate((valid) => {
          if (valid) {
            if(this.model == 'add'){
            save(this.row).then(res=>{
              this.$message.success("新增成功")
              this.$emit("success")
            })
        }else{
          if( this.row.userIdList.length ==0){
            this.row.userIdList = this.row.userIds.split(',')
          }
            update(this.row).then(res=>{
               this.$message.success("修改成功")
             this.$emit("success")
            })

        }
          } else {
            console.log('error submit!!');
            return false;
          }
        });

    },
    cancleRecord(){
     this.$emit("cancle")
    },
    async getContractTypeList(){
        let obj = {
            code:'project_contract_type',
            projectId:this.row.projectId
        }
      await  getBisDictData(obj).then(res=>{
            this.contractTypeList = res.data
        })
    },
    projectIdChange(){
        this.choicePeopleOption .projectId = this.row.projectId
          this.getContractTypeList()
    },
    transformGetPeople(data){
        this.row.userIdList = []
        data.forEach(element => {
            this.row.userIdList.push(element.id)
        });
        if(this.row.userIdList.length>0){
          this.$refs['formRef'].clearValidate('userIdList')
        }
    }

  },
};
</script>
